import React from 'react';
import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAdminPeriod } from '../../contexts/AdminPeriodContext';

export default function AdminTopbar() {
  const { user, signOut } = useAuth();
  const { period, setPeriod } = useAdminPeriod();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="admin-topbar">
      <div className="search">
        <Search size={16} />
        <input placeholder="Buscar loja, cliente, pedido..." />
      </div>

      <div className="actions">
        <label className="admin-period-select" aria-label="Selecionar periodo">
          <select value={period} onChange={(event) => setPeriod(event.target.value)}>
            <option value="day">Dia</option>
            <option value="month">Mes</option>
            <option value="year">Ano</option>
          </select>
        </label>

        <button className="admin-button secondary admin-topbar-btn" type="button">
          Notificacoes
          <span className="admin-notification-dot" aria-hidden="true" />
        </button>

        <button className="admin-button secondary admin-topbar-btn" type="button" onClick={handleLogout}>
          Sair
        </button>

        <div className="admin-user-chip">
          <div className="admin-user-role">Admin</div>
          <div className="admin-user-name">{user?.name || user?.email || 'Administrador'}</div>
        </div>
      </div>
    </div>
  );
}
